<template>
  <div class="home-categories-skeleton d-flex flex-wrap justify-content-center" style="gap: 20px;">
    <div
      v-for="n in count"
      :key="n"
      class="card-fillters home-category-skeleton d-flex flex-column align-items-center justify-content-center"
    >
      <Skeleton width="36px" height="24px" borderRadius="6px" />
      <Skeleton width="70%" height="12px" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "primevue/skeleton";

defineProps({
  count: { type: Number, default: 8 },
});
</script>

<style scoped lang="scss">
.home-category-skeleton {
  background-image: none !important;
  cursor: default;
  pointer-events: none;
  transform: none !important;
  gap: 10px;
}

.home-category-skeleton:hover,
.home-category-skeleton:focus {
  transform: none !important;
}
</style>
